var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"版本说明"}},[_c('VersionUpgrade')],1)}
var staticRenderFns = []

export { render, staticRenderFns }